export const SELLERS_BANNER_CAROUSEL_OPTIONS = {
  spaceBetween: 16,
  slidesPerView: 4,
  slidesPerGroup: 4,
  allowTouchMove: false,
  className: 'sellers-banner-carousel',
  breakpoints: {
    1222: { slidesPerView: 5, slidesPerGroup: 5 },
  },
};
